import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarCondicaoGeralSorteio, setModalDeletarCondicaoGeralSorteio } from "../redux/slices/condicaoGeralSorteio/condicaoGeralSorteioSlice";

export const cadastrarCondicaoGeralSorteio = createAsyncThunk("/CondicaoGeralSorteio/CadastrarCondicaoGeralSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/CondicaoGeralSorteio/CadastrarCondicaoGeralSorteio", payload.value);
    toastSucess("Condição geral cadastrada com sucesso");
    dispatch(setModalCadastrarCondicaoGeralSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarCondicaoGeralSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarCondicaoGeralSorteio = createAsyncThunk("/CondicaoGeralSorteio/BuscarCondicaoGeralSorteio", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/CondicaoGeralSorteio/BuscarCondicaoGeralSorteio", { params: { pesquisar: pesquisar } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarCondicaoGeralSorteioPorId = createAsyncThunk("/CondicaoGeralSorteio/BuscarCondicaoGeralSorteioPorId", async (id: number) => {
  try {
    const data = await api.get("/CondicaoGeralSorteio/BuscarCondicaoGeralSorteioPorId", { params: { id: id } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarCondicaoGeralSorteio = createAsyncThunk("/CondicaoGeralSorteio/AtualizarCondicaoGeralSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/CondicaoGeralSorteio/AtualizarCondicaoGeralSorteio", payload.value);
    toastSucess("Condição geral atualizada com sucesso");
    dispatch(setModalCadastrarCondicaoGeralSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarCondicaoGeralSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarCondicaoGeralSorteio = createAsyncThunk("/CondicaoGeralSorteio/DeletarCondicaoGeralSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/CondicaoGeralSorteio/DeletarCondicaoGeralSorteio", { params: { id: payload.value } });
    toastSucess("Condição geral removida com sucesso");
    dispatch(setModalDeletarCondicaoGeralSorteio(false));
    dispatch(setLoading(false));

    dispatch(buscarCondicaoGeralSorteio(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
